module.exports = __webpack_public_path__ + "img/general2-compressed.3ff2097e.jpg";